export const pages: string[] = [
    'start',               //0
    'markExpandButton',    //1
    'openModal',           //2
    'typeInput1',          //3
    'typeInput2',          //4
    'goToDNDQuestion',     //5
    'dragTen0',     
    'returnTen0',     
    'dragTen1',            //6
    'dragTen2',            //7
    'dragTen3',            //8
    'dragTen4',            
    'returnTen4',     
    'dragUnits1',          //9
       
    
]

export const getPage = (page: string) => {
    return pages.indexOf(page)
};


export const autoPageChange = [
    getPage('typeInput1'),
    getPage('dragTen0'),
    getPage('dragTen1'),
    getPage('dragTen2'),
    getPage('dragTen3')
];

